<template>
  <v-row no-gutters class="pt-4">
    <v-col cols="12" md="3" lg="3" xl="3">
      <div
        class="d-flex align-center field-post-media"
        style="min-height: 45px"
      >
        <v-icon class="fab fa-youtube mr-3" size="40" color="#EB5757"> </v-icon>
        <translate>Youtube</translate>
      </div>
    </v-col>
    <v-col cols="12" md="9" lg="9" xl="9">
      <v-combobox
        v-model="links"
        :items="[]"
        multiple
        chips
        :placeholder="$gettext('Youtube link')"
        @update:search-input="updateTargetInput"
        :search-input.sync="search"
        outlined
        hide-details="auto"
        dense
      >
        <template v-slot:selection="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            v-bind="data.attrs"
            :input-value="data.selected"
            :disabled="data.disabled"
            class="mb-1"
            small
            dense
          >
            <span class="font-weight-medium" style="margin-top: -3px">{{
              data.item.youtubeId || data.item
            }}</span
            >&nbsp;&nbsp;
            <v-icon
              class="fal fa-xmark"
              x-small
              @click="data.parent.selectItem(data.item)"
            />
          </v-chip>
        </template>
      </v-combobox>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "YoutubeInput",
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      links: [],
      search: null,
    };
  },
  mounted() {
    this.links = this.value;
  },
  methods: {
    reset() {
      this.links = [];
    },
    updateTargetInput(currentValue) {
      this.search = currentValue;
      if (this.search) {
        this.links = [...new Set([...this.links, ...this.search.split(",")])]; //   => remove duplication value in array
        this.$emit("input", this.links); // emit data
        this.$nextTick(() => {
          this.search = null;
        });
      }
    },
  },
};
</script>
